// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  kind: __t.string(),
  twinId: __t.option(__t.string()).name("twin_id"),
  modelDtmi: __t.option(__t.string()).name("model_dtmi"),
  componentName: __t.option(__t.string()).name("component_name"),
  telemetryName: __t.option(__t.string()).name("telemetry_name"),
  streamName: __t.option(__t.string()).name("stream_name"),
  message: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
